import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "File",
  "use": "File-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol viewBox=\"0 0 12 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"File\">\n<path d=\"M3.33317 9.66659H8.6665V10.9999H3.33317V9.66659ZM3.33317 6.99992H8.6665V8.33325H3.33317V6.99992ZM7.33317 0.333252H1.99984C1.2665 0.333252 0.666504 0.933252 0.666504 1.66659V12.3333C0.666504 13.0666 1.25984 13.6666 1.99317 13.6666H9.99984C10.7332 13.6666 11.3332 13.0666 11.3332 12.3333V4.33325L7.33317 0.333252ZM9.99984 12.3333H1.99984V1.66659H6.6665V4.99992H9.99984V12.3333Z\" fill=\"#002B48\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol